import env from '@/config/env';
import { errorGQLHandler } from '@/helpers/helpers';
import { getUF } from '@/utils/ufs';
import NOTICIAS_FAVORITAS from '@/graphql/revista/queries/NoticiaFavorita.gql';
import ADICIONAR_NOTICIA_FAVORITA from '@/graphql/revista/mutations/AdicionarNoticiaFavorita.graphql';
import REMOVER_NOTICIA_FAVORITA from '@/graphql/revista/mutations/RemoverNoticiaFavorita.graphql';

const SHOW_MODAL = 'SHOW_MODAL';
const SET_NOTICIAS = 'SET_NOTICIAS';
const MORE_NOTICIAS_FAVORITAS = 'MORE_NOTICIAS_FAVORITAS';
const SET_CARREGANDO = 'SET_CARREGANDO';
const SET_FAVORITOS = 'SET_FAVORITOS';
const SET_LAST_PAGE = 'SET_LAST_PAGE';
const SET_DEFAULT_LAST_PAGE = 'SET_DEFAULT_LAST_PAGE';
const RESET_MORE_NOTICIAS_FAVORITAS = 'RESET_MORE_NOTICIAS_FAVORITAS';

export default {
  namespaced: true,
  state: {
    noticiasFavoritas: [],
    showModal: false,
    // Modal Notify
    showComponentHeader: null,
    lastPage: '1',
    defaultLastPage: '1',
    perPage: 6,
    carregando: false,
    favorito: {
      ativo: false,
      corBase: '#dfdfdf',
      fill: '#dfdfdf',
    },
  },
  getters: {
    showModal: state => state.showModal,
    showComponentHeader: state => state.showComponentHeader,
    noticiasFavoritas: state => state.noticiasFavoritas,
    carregando: state => state.carregando,
    favorito: state => state.favorito,
    lastPage: state => state.lastPage,
    defaultLastPage: state => state.defaultLastPage,
  },
  mutations: {
    [SHOW_MODAL](state, bool) {
      state.showModal = bool;
      state.showComponentHeader = bool ? 'Favoritos' : null;
    },
    [SET_NOTICIAS](state, payload) {
      state.noticiasFavoritas = payload;
    },
    [MORE_NOTICIAS_FAVORITAS](state, payload) {
      state.perPage += payload;
    },
    [RESET_MORE_NOTICIAS_FAVORITAS](state) {
      state.perPage = 6;
    },
    [SET_CARREGANDO](state, payload) {
      state.carregando = payload;
    },
    [SET_FAVORITOS](state, payload) {
      state.favorito = payload;
    },
    [SET_LAST_PAGE](state, payload) {
      state.lastPage = payload;
    },
    [SET_DEFAULT_LAST_PAGE](state, payload) {
      state.defaultLastPage = payload;
    },
  },
  actions: {
    /**
     * @description Abre e fecha o modal de favoritos
     * @param commit
     * @param bool
     */
    showFavoritos({ commit }, bool) {
      if (bool) document.body.setAttribute('style', 'overflow: hidden');
      else document.body.removeAttribute('style');
      commit(SHOW_MODAL, bool);
    },

    /**
     * @description Lista todos os favoritos do usuário
     * @param rootGetters
     * @param limit
     */
    async fetchFavoritos({ rootGetters }, limit = null) {
      try {
        const {
          data: { noticias },
        } = await env.apolloRevista.query({
          query: NOTICIAS_FAVORITAS,
          variables: {
            modulo: env.revista.modulo,
            canal: env.revista.canal,
            uf: [rootGetters['user/uf']],
            paginate: limit ? limit : 6,
            funcao: rootGetters['user/userFunc'],
          },
          fetchPolicy: 'no-cache',
        });

        return noticias;
      } catch (e) {
        errorGQLHandler(e);
        return { data: [], last_page: '1' };
      }
    },
    async listFavoritos({ commit, dispatch }) {
      commit(SET_CARREGANDO, true);

      const noticias = await dispatch('fetchFavoritos');

      commit(SET_NOTICIAS, noticias.data);
      commit(SET_LAST_PAGE, noticias.last_page);
      commit(SET_DEFAULT_LAST_PAGE, noticias.last_page);
      commit(SET_CARREGANDO, false);
    },
    async moreFavoritos({ state, commit, dispatch }) {
      commit(SET_CARREGANDO, true);

      const noticias = await dispatch('fetchFavoritos', state.perPage + 6);

      commit(SET_NOTICIAS, noticias.data);
      commit(SET_LAST_PAGE, noticias.last_page);
      commit(SET_CARREGANDO, false);
      commit(MORE_NOTICIAS_FAVORITAS, 6);
    },

    handleHoverFavoritos({ commit, state }, { hover, leave, color }) {
      const favoritoTemp = state.favorito;

      color = color || '#660099';

      if (hover) {
        favoritoTemp.fill = color;
      } else if (leave) {
        favoritoTemp.fill = favoritoTemp.corBase;
      }

      commit(SET_FAVORITOS, favoritoTemp);
    },

    handleToggleFavoritos({ commit, state, rootGetters, dispatch }, id) {
      const favoritoTemp = state.favorito;

      favoritoTemp.ativo = !favoritoTemp.ativo;

      if (favoritoTemp.ativo) {
        try {
          favoritoTemp.corBase = '#EB1E5A';
          const ufs = rootGetters['uf/ufs'];
          const [ufId] = ufs.filter(uf => uf.sigla === rootGetters['user/uf']).map(item => item.id);

          env.apolloRevista
            .query({
              query: ADICIONAR_NOTICIA_FAVORITA,
              variables: { id, uf: ufId, canal: env.revista.canal, remover: 0 },
              fetchPolicy: 'no-cache',
            })
            .then(() => {
              dispatch('listFavoritos');
            });
        } catch (e) {
          console.log(e);
          errorGQLHandler(e);
          return;
        }
      } else {
        try {
          favoritoTemp.corBase = '#dfdfdf';

          env.apolloRevista
            .query({
              query: REMOVER_NOTICIA_FAVORITA,
              variables: { id },
              fetchPolicy: 'no-cache',
            })
            .then(() => {
              dispatch('listFavoritos');
            });
        } catch (e) {
          errorGQLHandler(e);
          return;
        }
      }

      favoritoTemp.fill = favoritoTemp.corBase;

      commit(SET_FAVORITOS, favoritoTemp);
    },
    async handleChangeFavoriteInSearch({ rootGetters }, { id, checked }) {
      if (!checked) {
        try {
          // add
          const uf = await getUF(rootGetters['user/uf'], 'sigla', 'id')[0];
          const canal = await env.revista.canal;
          const add = await env.apolloRevista.mutate({
            mutation: ADICIONAR_NOTICIA_FAVORITA,
            variables: { id, uf, canal, remover: 0 },
            fetchPolicy: 'no-cache',
          });

          return !!add;
        } catch (e) {
          return { error: true };
        }
      } else {
        // remove
        try {
          const remove = await env.apolloRevista.mutate({
            mutation: REMOVER_NOTICIA_FAVORITA,
            variables: { id },
            fetchPolicy: 'no-cache',
          });
          return !!remove;
        } catch (e) {
          return { error: true };
        }
      }
    },
    favorite({ commit, state }) {
      const favoritoTemp = state.favorito;

      favoritoTemp.corBase = '#EB1E5A';
      favoritoTemp.fill = favoritoTemp.corBase;
      favoritoTemp.ativo = true;

      commit(SET_FAVORITOS, favoritoTemp);
    },
    rmFavorite({ commit, state }) {
      const favoritoTemp = state.favorito;

      favoritoTemp.corBase = '#dfdfdf';
      favoritoTemp.fill = favoritoTemp.corBase;
      favoritoTemp.ativo = false;

      commit(SET_FAVORITOS, favoritoTemp);
    },
    resetMoreFavoritos({ commit }) {
      commit(RESET_MORE_NOTICIAS_FAVORITAS);
    },
  },
};
